import Dasboard from "./Dashboard";

export default Dasboard;
